import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  sendNotification,
  getStats,
  rowSelect,
  editcaregiver,
} from '../../store/action/patient.action'
import {
  Row,
  Col,
  Button,
  Modal,
  Card,
  Form,
  Input,
  Select,
  message,
  DatePicker,
} from 'antd'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import _ from 'lodash'
import '../../css/patient.scss'
import moment from 'moment'

const EditCareGiver = (props) => {
  var renderRelationshipOptions = () => {
    var RelationshipOptions = [
      { name: 'Spouse or Partner' },
      { name: 'Child' },
      { name: 'Sibling' },
      { name: 'Friend' },
      { name: 'Parent' },
      { name: 'Professional caregiver' },
      { name: 'Other' },
    ]
    return RelationshipOptions.map((Relation) => (
      <Select.Option value={Relation.name}>{Relation.name}</Select.Option>
    ))
  }

  var form = useRef(null)

  useEffect(() => {
    var date = props.date ? moment(props.date) : moment()
    form.current && form.current.setFieldsValue({ date })
  }, [props.date])

  var handleCancel = () => {
    form.current && form.current.resetFields()
    props.onClose()
  }

  var handleOk = () => {
    form.current.validateFields().then((values) => {
      console.log(values)
      props.addEvent(
        props.patient._id,
        {
          ...values,
          date: props.date && props.hideDate ? props.date : values.date,
        },
        props.patient
      )
      //form.current && form.current.resetFields();
      props.onSuccess()
    })
  }

  var disabledDate = (current) => {
    // Can not select days before today
    return current && current < moment().subtract(1, 'd').endOf('day')
  }

  var renderBody = (input) => {
    return (
      <Card bordered={true}>
        <Col>
          <Row>
            <Col flex={'auto'}>
              <Form
                ref={form}
                name='normal_login'
                initialValues={{
                  ...input?.caregiver,
                  phone: '+' + input?.caregiver?.phone,
                }}
                labelCol={{ span: 6 }}
                layout={'vertical'}
              >
                <Col className='careGiverInfoCont'>
                  <Form.Item
                    label='First Name'
                    name='fname'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter care giver first name',
                      },
                    ]}
                  >
                    <Input maxLength={100} />
                  </Form.Item>
                  <Form.Item
                    label='Last Name'
                    name='lname'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter care giver last name',
                      },
                    ]}
                  >
                    <Input maxLength={100} />
                  </Form.Item>

                  <Form.Item
                    label='Relationship'
                    name='relationship'
                    rules={[
                      {
                        required: true,
                        message:
                          'Please select a Relationship with care giver.',
                      },
                    ]}
                  >
                    <Select>{renderRelationshipOptions()}</Select>
                  </Form.Item>

                  <Form.Item
                    label='CELL PHONE'
                    name='phone'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter care giver cell number',
                      },
                      () => ({
                        validator(rule, value) {
                          var number = value
                            ? value.charAt(0) == '+'
                              ? value
                              : '+' + value
                            : ''
                          if (!value || isValidPhoneNumber(number)) {
                            return Promise.resolve()
                          }
                          return Promise.reject('Please enter valid number!')
                        },
                      }),
                    ]}
                  >
                    <PhoneInput className='phone-input' enableAreaCodes />
                  </Form.Item>

                  <Form.Item
                    label='Email'
                    name='email'
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid care giver email',
                        type: 'email',
                      },
                    ]}
                  >
                    <Input maxLength={50} />
                  </Form.Item>
                </Col>
              </Form>
            </Col>
          </Row>
        </Col>
      </Card>
    )
  }

  return (
    <Modal
      className={'filterModal'}
      visible={props.visible}
      closable={false}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      width={'70%'}
      okText={'Save'}
    >
      {renderBody(props.patient)}
    </Modal>
  )
}

EditCareGiver.propTypes = {
  customer: PropTypes.object,
  patientid: PropTypes.string,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  visible: PropTypes.bool,
  date: PropTypes.object,
  hideDate: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addEvent: (id, input, state) => dispatch(editcaregiver(id, input, state)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCareGiver)
